import { apiCall } from './gqlClient';
const GETCUSTOMERPROVIDERRECORDS_QUERY = "\n  query getCustomerProviderRecords($customerId: Int!) {\n    getCustomerProviderRecords(customerId: $customerId)\n    {\n      id\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tcategory\n\t\t\tpriority\n\t\t\tfileCreated\n\t\t\tdueDate\n\t\t\tquestions\n\t\t\tsteps\n      ...fragments\n    }\n  }";
export const getCustomerProviderRecordsApiCall = async function (_ref) {
  let {
    customerId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCUSTOMERPROVIDERRECORDS_QUERY,
    variables: {
      customerId
    },
    fragments
  });
};
const SAVECUSTOMERPROVIDERRECORD_QUERY = "\n  mutation saveCustomerProviderRecord($record: customerProviderRecordInput!) {\n    saveCustomerProviderRecord(record: $record)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const saveCustomerProviderRecordApiCall = async function (_ref2) {
  let {
    record
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVECUSTOMERPROVIDERRECORD_QUERY,
    variables: {
      record
    },
    fragments
  });
};
const ADDFILETORECORD_QUERY = "\n  mutation addFileToRecord($file: customerProviderRecordFileInput!) {\n    addFileToRecord(file: $file)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const addFileToRecordApiCall = async function (_ref3) {
  let {
    file
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDFILETORECORD_QUERY,
    variables: {
      file
    },
    fragments
  });
};
const UPDATECUSTOMERPROVIDERRECORD_QUERY = "\n  mutation updateCustomerProviderRecord($record: customerProviderRecordInput!) {\n    updateCustomerProviderRecord(record: $record)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateCustomerProviderRecordApiCall = async function (_ref4) {
  let {
    record
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECUSTOMERPROVIDERRECORD_QUERY,
    variables: {
      record
    },
    fragments
  });
};
const TOGGLERECORDPRIORITY_QUERY = "\n  mutation toggleRecordPriority($recordId: String!, $status: Boolean!) {\n    toggleRecordPriority(recordId: $recordId, status: $status)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleRecordPriorityApiCall = async function (_ref5) {
  let {
    recordId,
    status
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLERECORDPRIORITY_QUERY,
    variables: {
      recordId,
      status
    },
    fragments
  });
};
const DELETECUSTOMERPROVIDERRECORD_QUERY = "\n  mutation deleteCustomerProviderRecord($id: String!) {\n    deleteCustomerProviderRecord(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteCustomerProviderRecordApiCall = async function (_ref6) {
  let {
    id
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETECUSTOMERPROVIDERRECORD_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const REMOVEFILEFROMRECORD_QUERY = "\n  mutation removeFileFromRecord($fileId: String!) {\n    removeFileFromRecord(fileId: $fileId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const removeFileFromRecordApiCall = async function (_ref7) {
  let {
    fileId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REMOVEFILEFROMRECORD_QUERY,
    variables: {
      fileId
    },
    fragments
  });
};